// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2pnRD","bigColWidth":"Table_bigColWidth__3u8cR","biggerColWidth":"Table_biggerColWidth__27SHI","row":"Table_row__2YxXR","col":"Table_col__1Y0I8"};